@if ({}; as STATE) {
  <section class="competing-ads-layout"></section>
}
